import { combineReducers } from 'redux';
import { INITIALIZE_APP_ACTION } from '../actions';
import {
    SET_SOCIAL_DATA_ACTION,
    SET_EMAIL_ACTION,
    CLEAR_EMAIL_ACTION,
    SHOW_CAPTCHA,
    HIDE_CAPTCHA,
    SET_ACCOUNT_STATUS_CHECKED,
    SHOW_AUTH_NOTIFICATION,
    CLEAR_AUTH_NOTIFICATION,
    RE_REQUEST_PERMISSIONS,
    SHOW_LINKED_ACCOUNTS_DIALOG,
    FORCE_STLD,
} from '../actions/auth';
import { assign } from 'lodash';

const isAccountStatusChecked = (state = false, action) => {
    let nextState = state;

    if (action.type === SET_ACCOUNT_STATUS_CHECKED) {
        nextState = true;
    }

    return nextState;
};

const referrer = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.referrer;
    }

    return nextState;
};

const userTypeParams = (state = {}, action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.userTypeParams;
    }

    return nextState;
};

const forward = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.forward;
    }

    return nextState;
};

const pckg = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.pckg;
    }

    return nextState;
};

const stld = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.stld;
    }
    if (action.type === FORCE_STLD) {
        nextState = '1';
    }

    return nextState;
};

const email = (state = '', action) => {
    let nextState = state;

    if (
        action.type === SET_EMAIL_ACTION ||
        action.type === SET_ACCOUNT_STATUS_CHECKED
    ) {
        nextState = action.payload;
    } else if (action.type === CLEAR_EMAIL_ACTION) {
        nextState = '';
    }

    return nextState;
};

const socialData = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOCIAL_DATA_ACTION) {
        nextState = payload;
    }

    return nextState;
};

const locale = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.locale;
    }

    return nextState;
};

const isAuthenticated = (state = false, action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.isAuthenticated;
    }

    return nextState;
};

const recaptcha2PublicKey = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.recaptcha2PublicKey;
    }

    return nextState;
};

const recaptcha3PublicKey = (state = '', action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.recaptcha3PublicKey;
    }

    return nextState;
};

const displayCaptcha = (state = false, action) => {
    let nextState = state;

    if (action.type === SHOW_CAPTCHA) {
        nextState = true;
    } else if (action.type === HIDE_CAPTCHA) {
        nextState = false;
    }

    return nextState;
};

const fp = (state = false, action) => {
    let nextState = state;

    if (action.type === INITIALIZE_APP_ACTION) {
        nextState = action.payload.fp;
    }

    return nextState;
};

const authNotificationOptions = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === SHOW_AUTH_NOTIFICATION) {
        nextState = payload;
    } else if (type === CLEAR_AUTH_NOTIFICATION) {
        nextState = {};
    }

    return nextState;
};

const socialSSOSettings = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === INITIALIZE_APP_ACTION) {
        nextState = payload.socialSSOSettings;
    } else if (type === RE_REQUEST_PERMISSIONS) {
        nextState = state;
        nextState.facebook = assign(
            { reRequestPermissions: payload },
            state.facebook,
        );
    }

    return nextState;
};

const linkedAccountSuccessUrl = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SHOW_LINKED_ACCOUNTS_DIALOG) {
        nextState = payload.redirectUrl;
    }

    return nextState;
};

export const shouldIncludeEmailConfirmation = (
    state = false,
    { type, payload },
) => {
    let nextState = state;

    if (type === INITIALIZE_APP_ACTION) {
        nextState = payload.shouldIncludeEmailConfirmation;
    }

    return nextState;
};

// EXPERIMENT_MARRKER: SHOW_CREATOR_ENCOURAGEMENT
const showCreatorEncouragement = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === INITIALIZE_APP_ACTION) {
        if (payload && payload.featureFlags) {
            nextState = payload.featureFlags.showCreatorEncouragement;
        }
    }
    return nextState;
};

const disableRecaptcha3 = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === INITIALIZE_APP_ACTION) {
        if (payload && payload.featureFlags) {
            nextState = payload.featureFlags.disableRecaptcha3;
        }
    }
    return nextState;
};

export const hasConsumerOnboarding = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === INITIALIZE_APP_ACTION) {
        nextState = payload.hasConsumerOnboarding;
    }
    return nextState;
};

export const shouldShowAUSignUp = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === INITIALIZE_APP_ACTION) {
        nextState = payload.shouldShowAUSignUp;
    }

    return nextState;
};

export default combineReducers({
    referrer,
    userTypeParams,
    forward,
    email,
    locale,
    isAuthenticated,
    recaptcha2PublicKey,
    recaptcha3PublicKey,
    displayCaptcha,
    fp,
    pckg,
    stld,
    socialData,
    isAccountStatusChecked,
    authNotificationOptions,
    socialSSOSettings,
    linkedAccountSuccessUrl,
    shouldIncludeEmailConfirmation,
    showCreatorEncouragement,
    disableRecaptcha3,
    hasConsumerOnboarding,
    shouldShowAUSignUp,
});
